export const API_URL = `https://forkify-api.herokuapp.com/api/v2/recipes/`;
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = `ff92e3bf-ff83-4a2b-ad09-8e51399d8de2`;
export const MODAL_CLOSE_SEC = 2.5;